module.exports = __webpack_public_path__ + "img/78000.8bf44934.jpg";